<form
  [formGroup]="LocationForm"
  (ngSubmit)="onSubmit()"
  class="p-4"
>
  <!-- Información Básica -->
  <div class="grid">
    <div class="col-12">
      <h3 class="text-900 font-medium mb-3">{{ 'Información Básica' | translate }}</h3>
    </div>
    
    <!-- Tipo de Locación -->
    <div class="col-12 md:col-6">
      <div class="field">
        <label for="type_id" class="block text-900 font-medium mb-2">
          {{ 'Seleccionar Tipo' | translate }}
        </label>
        <p-autoComplete
          id="type_id"
          [suggestions]="(typeLocations$ | async)!"
          (completeMethod)="filterTypeLocations($event)"
          [minLength]="1"
          placeholder="{{ 'Buscar tipo' | translate }}"
          [dropdown]="true"
          formControlName="type_id"
          dataKey="id"
          (onSelect)="onSelectTypeLocation($event)"
          class="w-full"
          optionLabel="name"
        >
        </p-autoComplete>
      </div>
    </div>

    <!-- Nombre -->
    <div class="col-12 md:col-6">
      <div class="field">
        <label for="name" class="block text-900 font-medium mb-2">
          {{ 'Nombre' | translate }}
        </label>
        <input
          pInputText
          id="name"
          formControlName="name"
          type="text"
          class="w-full"
          placeholder="{{ 'Nombre de Locación' | translate }}"
        />
      </div>
    </div>

    <!-- Nombre a Mostrar -->
    <div class="col-12 md:col-6">
      <div class="field">
        <label for="display_name" class="block text-900 font-medium mb-2">
          {{ 'Nombre a Mostrar' | translate }}
        </label>
        <input
          pInputText
          id="display_name"
          formControlName="display_name"
          type="text"
          class="w-full"
          placeholder="{{ 'Nombre a Mostrar' | translate }}"
        />
      </div>
    </div>

    <!-- External ID -->
    <div class="col-12 md:col-6">
      <div class="field">
        <label for="external_id" class="block text-900 font-medium mb-2">
          {{ 'External Id' | translate }}
        </label>
        <input
          pInputText
          id="external_id"
          type="text"
          formControlName="external_id"
          class="w-full"
          placeholder="{{ 'External Id' | translate }}"
        />
      </div>
    </div>

    <!-- Descripción -->
    <div class="col-12 md:col-6">
      <div class="field">
        <label for="description" class="block text-900 font-medium mb-2">
          {{ 'Descripción' | translate }}
        </label>
        <input
          pInputText
          id="description"
          formControlName="description"
          type="text"
          class="w-full"
          placeholder="{{ 'Descripción' | translate }}"
        />
      </div>
    </div>
  </div>

  <!-- Relaciones y Jerarquía -->
  <div class="grid mt-4">
    <div class="col-12">
      <h3 class="text-900 font-medium mb-3">{{ 'Relaciones y Jerarquía' | translate }}</h3>
    </div>

    <!-- Tipo del Padre -->
    <div class="col-12 md:col-6">
      <div class="field">
        <label for="parent_type" class="block text-900 font-medium mb-2">
          {{ 'Tipo del Padre' | translate }}
        </label>
        <p-autoComplete
          id="parent_type"
          [suggestions]="(parentTypeLocations$ | async)!"
          (completeMethod)="filterParentTypeLocations($event)"
          [minLength]="1"
          placeholder="{{ 'Buscar tipo del padre' | translate }}"
          [dropdown]="true"
          dataKey="id"
          [(ngModel)]="locationParentType"
          [ngModelOptions]="{ standalone: true }"
          (onSelect)="onSelectParentTypeLocation($event)"
          class="w-full"
          optionLabel="name"
        >
        </p-autoComplete>
      </div>
    </div>

    <!-- Pertenece a -->
    <div class="col-12 md:col-6">
      <div class="field">
        <label for="parent_id" class="block text-900 font-medium mb-2">
          {{ 'Pertenece a' | translate }}
          <span class="text-red-500" *ngIf="!locationParentType">*</span>
        </label>
        <p-autoComplete
          id="parent_id"
          [suggestions]="Locations"
          (completeMethod)="filterLocations($event)"
          [minLength]="1"
          [placeholder]="locationParentType ? ('Buscar locación padre' | translate) : ('Primero selecciona un tipo del padre' | translate)"
          [dropdown]="true"
          formControlName="parent_id"
          dataKey="id"
          (onSelect)="onSelectLocation($event)"
          class="w-full"
          optionLabel="name"
          [disabled]="!locationParentType"
        >
        </p-autoComplete>
        <small class="text-600 mt-1" *ngIf="!locationParentType">
          {{ 'Debe seleccionar un tipo del padre primero' | translate }}
        </small>
      </div>
    </div>
  </div>

  <!-- Configuración de Iconos -->
  <div class="grid mt-4" *ngIf="showIcon">
    <div class="col-12">
      <h3 class="text-900 font-medium mb-3">{{ 'Configuración Visual' | translate }}</h3>
    </div>
    
    <div class="col-12">
      <div class="field">
        <label class="block text-900 font-medium mb-2">
          {{ 'Agregar Iconos' | translate }}
        </label>
        <button
          pButton
          type="button"
          class="p-button-outlined p-button-help"
          [label]="showListIcon ? 'Ocultar lista' : 'Mostrar lista'"
          icon="pi pi-list"
          (click)="showListIcon = !showListIcon"
        ></button>
      </div>
    </div>
  </div>

  <!-- Lista de Iconos -->
  <div class="grid mt-3" *ngIf="showListIcon">
    <div class="col-12">
      <div class="card">
        <p-orderList
          [value]="LocaionIcon"
          [listStyle]="{ 'max-height': '400px' }"
          header="{{ 'Seleccionar un icono' | translate }}"
          (onSelectionChange)="selectionIcon($event)"
        >
          <ng-template let-icon pTemplate="item">
            <div class="flex align-items-center p-3 border-bottom-1 surface-border">
              <div class="flex-shrink-0">
                <kanzi-floormap-preview-item
                  [type]="'FURNITURE'"
                  [furniture]="icon"
                ></kanzi-floormap-preview-item>
              </div>
              <div class="ml-3 flex-1">
                <div class="text-900 font-medium mb-1">{{ 'Nombre' | translate }}:</div>
                <div class="flex align-items-center text-600">
                  <i class="pi pi-tag mr-2"></i>
                  <span>{{ icon.title }}</span>
                </div>
              </div>
            </div>
          </ng-template>
        </p-orderList>
      </div>
    </div>
  </div>

  <!-- Botones de Acción -->
  <div class="grid mt-4">
    <div class="col-12 text-center">
      <div class="flex justify-content-center gap-2">
        <button 
          pButton 
          type="submit" 
          [disabled]="!LocationForm.valid"
          class="p-button-success"
          icon="pi pi-check"
        >
          {{ 'Guardar' | translate }}
        </button>
        <button 
          pButton 
          type="reset" 
          class="p-button-outlined p-button-secondary"
          icon="pi pi-times"
        >
          {{ 'Cancelar' | translate }}
        </button>
      </div>
    </div>
  </div>

  <!-- Loading Overlay -->
  <div
    class="fixed top-0 left-0 w-full h-full bg-black-alpha-50 flex align-items-center justify-content-center z-5"
    *ngIf="isPending$ | async"
  >
    <div class="bg-white border-round p-4 shadow-3 text-center">
      <i class="pi pi-spin pi-spinner text-primary text-4xl mb-3"></i>
      <div class="text-900 font-medium">{{ 'Procesando...' | translate }}</div>
    </div>
  </div>
</form>
